import axios from 'axios';

const BASE_URL = 'https://collegemate.up.railway.app/'; // Include the protocol (http:// or https://)
const axiosInstance = axios.create({
  baseURL: BASE_URL,
});

export default axiosInstance;
// 192.168.132.204
// 'https://collegemate.up.railway.app/';